import { observer } from "mobx-react-lite";
import React, { useMemo, useState, useRef } from "react";
import { currentUserService } from "../../services/user/CurrentUserStorage";
import { HeaderProfile } from "../svg/svgImageList";
import useThemeService from "../../services/theme-service/ThemeService";
import Button from "../button/Button";
import HeaderProfileMenu from "./HeaderProfileMenu";

export interface IProfileButtonProps {
    logoutFunction?(): void;
    children?: any;
}

export default observer(function ProfileButton(props: IProfileButtonProps) {
    const { themeClass } = useThemeService();
    const myAccountButtonRef = useRef(null);
    const [showHeaderProfileMenu, setShowHeaderProfileMenu] = useState(false);

    const getProfilePicture = useMemo(() => {
        const profilePictureUrl = currentUserService.currentUser.image?.url;
        if (!profilePictureUrl) return;
            return <img className={"profile-mini-picture"} src={profilePictureUrl} alt="Profile" />;
    }, []);

    return (
        <>
            <Button
                id="navbar-header-profile"
                type="button"
                ref={myAccountButtonRef}
                textKey={currentUserService.currentUser.name || ""}
                icon={{ svg: HeaderProfile, className: themeClass(["header-profile-icon"]) }}
                component={getProfilePicture}
                className={themeClass(["navbar-header-profile"])}
                onClick={() => setShowHeaderProfileMenu(true)}
            />
            <HeaderProfileMenu
                isVisible={showHeaderProfileMenu}
                anchorElement={myAccountButtonRef.current}
                close={() => setShowHeaderProfileMenu(false)}
                onLogout={props.logoutFunction}
            >
                {props.children}
            </HeaderProfileMenu>
        </>
    )
})